import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

interface RegistrationCompletedProps {
    title: string,
    information: string,
    continueButtonLabel: string,
    onContinue: () => void;
}

const RegistrationCompleted: React.SFC<RegistrationCompletedProps> = (props) => {
    return <Grid item xs>
        <Typography variant="h3">{props.title}</Typography>
        <Typography paragraph variant="body2">{props.information}</Typography>
        <Button onClick={props.onContinue}>{props.continueButtonLabel}</Button>
    </Grid>
}

export default RegistrationCompleted;


// WEBPACK FOOTER //
// ./src/register/user/RegistrationCompleted.tsx